import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ModalConfigService } from '../../utils/modal-config.service';
import { globalConst } from '../../constant/constant';
import { UtilService } from '../..//utils/util.service';
import { PaymentService } from './payment.service';
import { EventBusService } from '../../service/event-bus.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit, OnDestroy {

  constructor(
    private utilService: UtilService,
    private modalConfigService: ModalConfigService,
    private eventBusService: EventBusService,
    public paymentService: PaymentService
  ) { }

  @Input() goods: any;
  @Input() orderWay: 1 | 2 | 5;
  @Input() price: any;


  public orderId: number;
  public codeUrl: string;
  public ordersNo: string;
  public orderInfo = {}

  public interval: any; // 定时器


  /**
   * 支付弹窗
   */
  public payModalShow: boolean = false;
  public paymentInProgress: boolean = false; // 

  ngOnInit() {

  }
  /**
   * A callback method that performs custom clean-up, invoked immediately
   * before a directive, pipe, or service instance is destroyed.
   */
  ngOnDestroy(): void {
    if (this.interval) {
      this.wxPayResultSave(2);
      clearInterval(this.interval);
    }
  };



  // 提交订单
  async submit() {
    try {
      const params = {
        orderWay: this.orderWay,
        orderData: this.goods
      }

      const orders = await this.paymentService.addOrders(params);
      this.orderId = orders.id;
      this.ordersNo = orders.payNo;

      const { data: wxPay } = await this.paymentService.wxPay(this.orderId);
      this.codeUrl = wxPay.codeUrl;

      this.payModalShow = true;
      this.audioPlay();
    } catch (error) {
      this.modalConfigService.errMsg(error?.message || globalConst.Tip.Common_Error_Tip);
    }
  }

  // 开/关 支付弹窗
  choosePay() {
    if (this.interval) {
      this.wxPayResultSave(2);
      clearInterval(this.interval);
    }
    this.payModalShow = !this.payModalShow;
  }





  // 查询订单状态
  public counter = 1;
  audioPlay() {
    this.interval = setInterval(() => {
      if (this.counter > 90) {
        //  清除定时器
        // 支付超时
        this.counter = 1;
        this.wxPayResultSave(2);
        this.modalConfigService.successMsg(globalConst.Tip.Payment_Overtime);
        clearInterval(this.interval);
      } else {
        this.wxPayResult();
        this.counter = ++this.counter;
      }
    }, 10000);
  }



  /**
   * 查询订单
   * trade_state：
   * 
   * 交易状态，枚举值：
   * NOTPAY 未支付
   * USERPAYING 用户支付中（仅付款码支付会返回）
   * 
   * SUCCESS 支付成功
   * 
   * REFUND 转入退款
   * CLOSED 已关闭
   * REVOKED 已撤销（仅付款码支付会返回）
   * PAYERROR 支付失败（仅付款码支付会返回）
   * 
   */
  async wxPayResult() {
    try {
      const { data } = await this.paymentService.wxPayResult(this.orderId);
      const tradeState = data.tradeState;

      // 支付中
      if (tradeState === 'NOTPAY') {
        return;
      }

      // 支付中
      if (tradeState === 'USERPAYING') {
         this.paymentInProgress = true;
        return;
      }

      if (tradeState === 'SUCCESS') {
        // 成功
        this.wxPayResultSave();
        this.modalConfigService.successMsg(globalConst.Tip.Payment_Success);
      } else if (tradeState === 'REFUND' || tradeState === 'CLOSED' || tradeState === 'REVOKED' || tradeState === 'PAYERROR') {
        // 失败
        this.modalConfigService.successMsg(globalConst.Tip.Payment_Error);
        this.wxPayResultSave(2);
      }

      clearInterval(this.interval);
    } catch (error) {
      this.modalConfigService.errMsg(error?.message || globalConst.Tip.Common_Error_Tip);
    }
  }



  /**
   * 保存订单状态
   * @param result  1为成功，2为失败
   */
  async wxPayResultSave(result = 1) {
    try {
      await this.paymentService.wxPayResultSave(this.orderId, { result });
      this.codeUrl = '';
      this.orderInfo = {};
      this.goods = {};
      this.payModalShow = false;
      this.eventBusService.loginEvent.next(null);
    } catch (error) {
      this.modalConfigService.errMsg(error?.message || globalConst.Tip.Common_Error_Tip);
    }
  }


}
